/* istanbul ignore file */
import { array as codecArray, boolean as codecBoolean, number as codecNumber, oneOf as codecOneOf, string as codecString, } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { DeletedCommentReply } from './DeletedCommentReply';
import { ExtendedNonDeletedCommentReply } from './ExtendedNonDeletedCommentReply';
import { NotificationReasons } from './NotificationReasons';
const BaseNotificationParser = /* #__PURE__ */ parsers.lazy(() => 
/* #__PURE__ */ parsers.object([
    ['id', codecNumber],
    ['read', codecBoolean],
    [
        'reasons',
        /* #__PURE__ */ codecArray(
        /* #__PURE__ */ codecArray(
        /* #__PURE__ */ codecOneOf([NotificationReasons, codecString]))),
    ],
    ['createdAt', parsers.moment, 'created_at'],
    ['commentBaseId', codecNumber, 'comment_base_id'],
    ['workId', codecNumber, 'work_id'],
    ['assignmentId', codecNumber, 'assignment_id'],
    [
        'commentReply',
        /* #__PURE__ */ codecOneOf([ExtendedNonDeletedCommentReply, DeletedCommentReply]),
        'comment_reply',
    ],
]));
export class BaseNotification extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return BaseNotificationParser.decode(input).map(res => new BaseNotification(res));
    }
    static unsafeDecode(input) {
        return BaseNotification.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return BaseNotificationParser.encode(data);
    }
    static schema() {
        return BaseNotificationParser.schema();
    }
}
